import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { createAgent, searchAgent } from "../../../RTK/AgentsSlice";
import SearchResultsPopup from "./SearchParentID";
import { 
  Search,
  X, 
  UserPlus, 
  AlertCircle,
  ChevronLeft,
  Database,
  Users,
  Plus
} from "lucide-react";

const CreateAgentPopup = ({ setShowPopup, productId, agents }) => {
  const dispatch = useDispatch();
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [results, setResults] = useState([]);
  const [isResultsOpen, setIsResultsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [parentId, setParentId] = useState("");

  const handleAddAgent = () => {
    if (selectedAgent && parentId) {
      dispatch(
        createAgent({ productId, agentsID: selectedAgent, parentID: parentId })
      );
      setShowPopup(false);
    }
  };

  const handleSearchClick = async () => {
    if (!searchQuery || !selectedAgent) return;
    try {
      const response = await dispatch(
        searchAgent({ agent_id: selectedAgent, query: searchQuery })
      );
      if (response.payload?.length > 0) {
        setResults(response.payload);
        setIsResultsOpen(true);
      }
    } catch (error) {
      console.error("Search error:", error);
    }
  };

  return (
    <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/70 backdrop-blur-md z-[11500]" />

      {/* Popup Content */}
      <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[90%] max-w-2xl z-[12000]" dir="rtl">
        <div className="bg-gradient-to-b bg-gray-900 rounded-2xl border border-gray-800/50 shadow-2xl overflow-hidden">
          {/* Header - ثابت */}
          <div className="relative flex justify-between items-center p-6 after:absolute after:bottom-0 after:left-0 after:right-0 after:h-px after:bg-gradient-to-r after:from-transparent after:via-gray-700/50 after:to-transparent">
            <h2 className="text-xl font-bold text-white flex items-center gap-3">
              <UserPlus className="w-6 h-6 text-[#FEC111]" />
              <span className="bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent">
                إضافة وكيل جديد
              </span>
            </h2>
            <button
              onClick={() => setShowPopup(false)}
              className="text-gray-400 w-10 h-10 rounded-full flex items-center justify-center bg-gray-800/50 hover:bg-[#FEC111] hover:text-black transition-all duration-300 hover:scale-105"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* Content Area */}
          <div className="p-6 space-y-6">
            {/* Search Section - ثابت */}
            <div className="flex flex-col sm:flex-row gap-3">
              <div className="relative flex-1">
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="البحث عن تفاصيل الوكيل..."
                  className="w-full px-12 py-3 rounded-xl bg-gray-900/50 text-white border border-gray-800/50 focus:border-[#FEC111]/50 focus:ring-1 focus:ring-[#FEC111]/50 transition-colors placeholder:text-gray-500"
                />
                <Search className="w-5 h-5 text-gray-400 absolute right-4 top-1/2 transform -translate-y-1/2" />
              </div>
              <button
                onClick={handleSearchClick}
                disabled={!searchQuery || !selectedAgent}
                className="px-6 py-3 bg-[#FEC111] text-black rounded-xl hover:bg-[#FEC111]/90 transition-all duration-300 font-bold flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <Search className="w-5 h-5" />
                بحث
              </button>
            </div>

            {/* Agents Selection - جزء الـ scroll الوحيد */}
            <div className="space-y-3">
              <h3 className="text-white font-semibold flex items-center gap-2">
                <Users className="w-5 h-5 text-[#FEC111]" />
                اختر الوكيل ({agents.length} وكيل)
              </h3>
              
              {/* هذا الجزء فقط له scroll */}
              <div className="max-h-[200px] overflow-y-auto custom-scrollbar border border-gray-700/30 rounded-xl p-3 bg-gray-900/50">
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                  {agents.map((ags) => (
                <label
                  key={ags.id}
                  className={`group flex items-center gap-3 p-3 rounded-xl cursor-pointer transition-all duration-300 hover:scale-[1.02] ${
                    selectedAgent === ags.id 
                      ? 'bg-[#FEC111] text-black border-transparent' 
                      : 'bg-slate-800/50 text-white border border-gray-800/50 hover:border-gray-700/50'
                  }`}
                >
                      <input
                    type="radio"
                    name="agent"
                    value={ags.id}
                    checked={selectedAgent === ags.id}
                    onChange={() => setSelectedAgent(ags.id)}
                    className="hidden"
                  />
                  <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${
                    selectedAgent === ags.id ? 'bg-black/10' : 'bg-gray-800/50'
                  }`}>
                    <Users className="w-4 h-4" />
                  </div>
                  <span className="flex-1">{ags.name}</span>
                  <ChevronLeft className={`w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity`} />
                </label>
              ))}
            </div>
              </div>
            </div>

            {/* Parent ID Input - ثابت */}
            <div className="space-y-3">
              <h3 className="text-white font-semibold flex items-center gap-2">
                <Database className="w-5 h-5 text-[#FEC111]" />
                معرف الوكيل
              </h3>
              
              <div className="relative">
                <input
                  type="text"
                  value={parentId}
                  onChange={(e) => setParentId(e.target.value)}
                  placeholder="إدخال معرف الوكيل..."
                  className="w-full px-12 py-3 rounded-xl bg-gray-900/50 text-white border border-gray-600/50 focus:border-[#FEC111]/50 focus:ring-1 focus:ring-[#FEC111]/50 transition-colors placeholder:text-gray-500"
                />
                <Database className="w-5 h-5 text-gray-400 absolute right-4 top-1/2 transform -translate-y-1/2" />
              </div>
            </div>

            
          </div>

          {/* Footer - ثابت */}
          <div className="flex flex-col-reverse sm:flex-row justify-between gap-3 p-6 border-t border-gray-800/50">
            <button
              onClick={() => setShowPopup(false)}
              className="flex items-center justify-center gap-2 py-3 px-6 bg-gray-950/50 text-white rounded-xl hover:bg-gray-800 transition-all duration-300 font-bold"
            >
              <X className="w-5 h-5" />
              إلغاء
            </button>
            
            <button
              onClick={handleAddAgent}
              disabled={!selectedAgent || !parentId}
              className="flex items-center justify-center gap-2 py-3 px-6 bg-[#FEC111] text-black rounded-xl hover:bg-[#FEC111]/90 transition-all duration-300 font-bold disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <Plus className="w-5 h-5" />
              إضافة وكيل
            </button>
          </div>
        </div>
      </div>

      {/* Search Results Popup */}
      {isResultsOpen && (
        <SearchResultsPopup
          results={results}
          onClose={() => setIsResultsOpen(false)}
        />
      )}

      {/* Custom Scrollbar Styles */}
      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 6px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: rgba(75, 85, 99, 0.2);
          border-radius: 3px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: rgba(254, 193, 17, 0.5);
          border-radius: 3px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: rgba(254, 193, 17, 0.7);
        }
        .custom-scrollbar {
          scrollbar-width: thin;
          scrollbar-color: rgba(254, 193, 17, 0.5) rgba(75, 85, 99, 0.2);
        }
      `}</style>
    </>
  );
};

export default CreateAgentPopup;